import { render } from "./RootLocationPill.vue?vue&type=template&id=21f7f619"
import script from "./RootLocationPill.vue?vue&type=script&lang=js"
export * from "./RootLocationPill.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\phili\\work\\dingsda\\dingsda_2mex_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__